import { TripState, GetTripResponse } from "Application/models";
import { getTripData } from "Application/service";
import { create } from "zustand";

export const useTripStore = create<TripState>((set) => ({
  isLoading: false,
  isError: false,
  error: null,
  tripData: [],

  getTrip: async () => {
    set({ isLoading: true });

    try {
      const response: GetTripResponse = await getTripData();

      set({isError: false, error: null,tripData: response });

    } catch (error) {
        set({ error: 'Failed to get countries', isError: true });
        throw error;
    } finally {
      set({ isLoading: false });
    }
  }
}));